import axios from "../axiosPlugin.js";

export const getBrandList = (data, loading = true) => {
  return axios({
    url: "/api/brand/list",
    method: 'get',
    data: {
      data,
      loading
    },
  })
}

export const createBrand = (data, loading = true) => {
  return axios({
    url: "/api/brand/create",
    method: 'post',
    data: {
      data,
      loading
    },
  })
}

export const deleteBrand = (data, loading = true) => {
  return axios({
    url: "/api/brand/delete/" + data.id,
    method: 'delete',
    data: {
      data: {},
      loading
    },
  })
}

export const getBrandDetail = (data, loading = true) => {
  return axios({
    url: "/api/brand/detail/" + data.id,
    method: 'get',
    data: {
      data: {},
      loading
    },
  })
}

export const updateBrand = (data, loading = true) => {
  return axios({
    url: "/api/brand/update",
    method: 'put',
    data: {
      data,
      loading
    },
  })
}

export const loginAsBrand = (data, loading = true) => {
  return axios({
    url: "/api/brand/loginAs/" + data.id,
    method: 'get',
    data: {
      loading,
    },
  })
}
